var _defs, _style, _g, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCabletvSvgTrans(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    width: 500,
    height: 500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\n\t\tCabletv-svg\n\t") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m77 172.82h345v248.96h-345z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #0077b6 }\n\t\t.s1 { fill: #ff6800 }\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m421.8 381.4c0 10.7-4.3 21-11.9 28.6-7.6 7.6-17.9 11.8-28.7 11.8-63.9 0-199.5 0-263.5 0-10.7 0-21-4.2-28.6-11.8-7.6-7.6-11.9-17.9-11.9-28.6 0-45 0-123 0-168 0-10.7 4.3-21 11.9-28.6 7.6-7.6 17.9-11.8 28.6-11.8 64 0 199.6 0 263.5 0 10.8 0 21.1 4.2 28.7 11.8 7.6 7.6 11.9 17.9 11.9 28.6 0 45 0 123 0 168zm-20-188.5c-5.5-5.4-12.9-8.5-20.6-8.5-63.9 0-199.5 0-263.5 0-7.7 0-15 3.1-20.5 8.5-5.4 5.5-8.5 12.8-8.5 20.5 0 45 0 123 0 168 0 7.7 3.1 15 8.5 20.5 5.5 5.4 12.8 8.4 20.5 8.4 64 0 199.6 0 263.5 0 7.7 0 15.1-3 20.6-8.4 5.4-5.5 8.5-12.8 8.5-20.5 0-45 0-123 0-168 0-7.7-3.1-15-8.5-20.5z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m350.4 368.4c0 9.8-8 17.8-17.8 17.8-39.3 0-162.7 0-201.9 0-9.8 0-17.8-8-17.8-17.8 0-30.7 0-111.4 0-142 0-9.9 8-17.8 17.8-17.8 39.2 0 162.6 0 201.9 0 9.8 0 17.8 7.9 17.8 17.8zm-17.8-148.4c-39.3 0-162.7 0-201.9 0-3.5 0-6.3 2.8-6.3 6.3 0 30.7 0 111.4 0 142.1 0 3.5 2.8 6.3 6.3 6.3 39.2 0 162.6 0 201.9 0 3.5 0 6.3-2.8 6.3-6.3v-142.1c0-3.5-2.8-6.3-6.3-6.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m297.1 178.7v5.7h-95.2c-3.2 0-5.7-2.5-5.7-5.7q0 0 0 0c0-11 4.3-21.5 12.1-29.2 7.8-7.8 18.3-12.2 29.3-12.2 7.8 0 16 0 23.8 0 22.9 0 41.4 18.6 41.4 41.4zm-6.3-5.7c-2.7-13.8-14.8-24.2-29.4-24.2-7.7 0-16 0-23.8 0-7.9 0-15.5 3.2-21.1 8.8-4.3 4.2-7.1 9.6-8.2 15.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m249.5 133.4l80-54.4c2.6-1.8 6.2-1.1 8 1.5 1.8 2.6 1.1 6.2-1.5 8l-83.3 56.6c-1.9 1.4-4.5 1.4-6.5 0l-83.2-56.6c-2.6-1.8-3.3-5.4-1.5-8 1.8-2.6 5.3-3.3 8-1.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m398 285.5c0 3.2-2.6 5.8-5.8 5.8h-23.8c-3.1 0-5.7-2.6-5.7-5.8v-23.7c0-3.2 2.6-5.8 5.7-5.8h23.8c3.2 0 5.8 2.6 5.8 5.8zm-23.8-18v12.2h12.3v-12.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m398 333c0 3.2-2.6 5.7-5.8 5.7h-23.8c-3.1 0-5.7-2.5-5.7-5.7v-23.7c0-3.2 2.6-5.8 5.7-5.8h23.8c3.2 0 5.8 2.6 5.8 5.8zm-23.8-18v12.2h12.3v-12.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCabletvSvgTrans);
export default __webpack_public_path__ + "static/media/Cabletv-svg-trans.e4c856951936d5e428e688aef15464e8.svg";
export { ForwardRef as ReactComponent };